// Ciclo de hover com as 4 cores da logo (verde → vermelho → azul → amarelo),
// aplicado pela posição do item (índice % 4). Classes estáticas para o Tailwind.
export const hoverBgCycle = [
  'hover:bg-brand-green/10 hover:text-brand-green focus-visible:bg-brand-green/10 focus-visible:text-brand-green',
  'hover:bg-brand-red/10 hover:text-brand-red focus-visible:bg-brand-red/10 focus-visible:text-brand-red',
  'hover:bg-brand-blue/10 hover:text-brand-blue focus-visible:bg-brand-blue/10 focus-visible:text-brand-blue',
  'hover:bg-brand-yellow/15 hover:text-brand-yellow-dark focus-visible:bg-brand-yellow/15 focus-visible:text-brand-yellow-dark',
];

export const hoverTextCycle = [
  'hover:text-brand-green',
  'hover:text-brand-red',
  'hover:text-brand-blue',
  'hover:text-brand-yellow-dark',
];

// Texto fixo no ciclo das 4 cores (sem hover) — usado no destaque do desconto.
export const textCycle = [
  'text-brand-green',
  'text-brand-red',
  'text-brand-blue',
  'text-brand-yellow-dark',
];


// Destaque da categoria selecionada no megamenu, também no ciclo das 4 cores
// (hover na coluna interna seleciona a categoria, então a seleção define a cor vista).
export const activeCycle = [
  'bg-brand-green/10 text-brand-green',
  'bg-brand-red/10 text-brand-red',
  'bg-brand-blue/10 text-brand-blue',
  'bg-brand-yellow/15 text-brand-yellow-dark',
];

